import RequestPlugin from "./request";
import SparkMD5 from 'spark-md5';
let extend = {};



//其他扩展
extend.install = function (Vue, options) {




    /**
     * 获取本地存储的token值
     * @returns {string}
     */
    window.getLocalToken = function() {
        return localStorage.getItem("token");
    }

    /**
     * 更新本地存储的token值，同时更新updateTime
     * @param token
     */
    window.updateLocalToken = function(token) {
        localStorage.setItem("token", token);
        if (token) {
            localStorage.setItem("tokenUpdateTime", new Date().getTime());
        } else {
            localStorage.setItem("tokenUpdateTime", "");
        }
    }

    /**
     * 检测token是否需要更新了，一般是距离上次更新有25分钟了，就需要更新一下了
     */
    window.checkTokenNeedRefresh = function() {
        let token = localStorage.getItem("token");
        if (!token) return false;
        let lastTime = localStorage.getItem("tokenUpdateTime");
        if (!lastTime) return true;
        return (new Date().getTime() - Number(lastTime) >= 25*60*1000);
    }



    /**
     * 打开一个新标签页
     * @param url
     */
    window.openTab = function (url) {
        var a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("target", "_blank");
        var e = document.createEvent('MouseEvents');
        e.initEvent('click', true, true);
        a.dispatchEvent(e);
    }

    /**
     * 获取url中的参数
     * @param name
     * @returns {string|null}
     */
    window.getUrlParam = function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let search = window.location.search;
        var r = search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    };
    /**
     * 时间格式化
     */
    Date.prototype.format = function(fmt) { //author: meizz
        var o = {
            "M+" : this.getMonth() + 1, //月份
            "d+" : this.getDate(), //日
            "h+" : this.getHours(), //小时
            "m+" : this.getMinutes(), //分
            "s+" : this.getSeconds(), //秒
            "q+" : Math.floor((this.getMonth() + 3) / 3), //季度
            "S" : this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }

    /**
     * 计算文件MD5
     * @param file
     * @param handler
     */
     window.calFileMd5 = function(file, handler) {
        let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
            chunkSize = 2097152,                             // Read in chunks of 2MB
            chunks = Math.ceil(file.size / chunkSize),
            currentChunk = 0,
            spark = new SparkMD5.ArrayBuffer(),
            fileReader = new FileReader();

        fileReader.onload = function (e) {
            spark.append(e.target.result);                   // Append array buffer
            currentChunk++;

            if (currentChunk < chunks) {
                loadNext();
            } else {
                if(handler) {
                    handler(file, spark.end());
                }
            }
        };

        fileReader.onerror = function () {
        };

        function loadNext() {
            var start = currentChunk * chunkSize,
                end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;

            fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
        }

        loadNext();
    }

}

export default extend;
